import {
  Button,
  Checkbox,
  Dialog,
  FilePicker,
  Group,
  Overlay,
  Pane,
  Radio,
  Spinner,
  Text,
  TextInputField,
} from "evergreen-ui";
import thaid1 from "../../assets/2026/thai/ThaID1.png";
import { admission, arit, mua, muaStatic } from "../../config/api";

import thaid2 from "../../assets/2026/thai/2.png";
import { IoMdHelpBuoy } from "react-icons/io";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import axios from "axios";
import { day, firstgen, month, objTypePre_Bak, selectorigin, selectreligion } from "./DATA/data";
import { FaFacebook } from "react-icons/fa6";
import Swal from "sweetalert2";
import Iframe from "react-iframe";
import {
  listFieldErrors,
  rulesCitizenId,
  rulesEmail,
  rulesEmailOrDash,
  rulesEnglishName,
  rulesPhone,
  rulesThaiName,
  rulesZipcode,
} from "./formValidation";
import "./FormProfileNewBee.css";

const MAX_PDF_BYTES = 3 * 1024 * 1024; // 3 MB

function formatFileSize(bytes) {
  const n = Number(bytes) || 0;
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / (1024 * 1024)).toFixed(2)} MB`;
}

function isPdfFile(file) {
  if (!file) return false;
  const name = String(file.name || "").toLowerCase();
  return file.type === "application/pdf" || name.endsWith(".pdf");
}

/** แจ้งเตือนเมื่อไฟล์ใหญ่เกิน / ไม่ใช่ PDF — คืน true ถ้าผ่าน */
function alertIfInvalidPdf(file, docLabel = "เอกสาร") {
  if (!file) return false;
  const swalOpts = {
    heightAuto: false,
    confirmButtonText: "ตกลง",
    didOpen: () => {
      const el = document.querySelector(".swal2-container");
      if (el) el.style.zIndex = "200000";
    },
  };
  if (!isPdfFile(file)) {
    Swal.fire({
      ...swalOpts,
      icon: "warning",
      title: "ชนิดไฟล์ไม่ถูกต้อง",
      html: `<p style="margin:0 0 8px">ช่องนี้รับเฉพาะไฟล์ <b>PDF</b></p>
             <p style="margin:0;color:#666">ไฟล์ที่เลือก: ${file.name || "-"}</p>`,
    });
    return false;
  }
  if (file.size > MAX_PDF_BYTES) {
    Swal.fire({
      ...swalOpts,
      icon: "error",
      title: "ไฟล์ใหญ่เกิน 3 MB",
      html: `<p style="margin:0 0 8px"><b>${docLabel}</b></p>
             <p style="margin:0 0 4px">ไฟล์: <b>${file.name || "-"}</b></p>
             <p style="margin:0 0 4px">ขนาดที่เลือก: <b style="color:#c0392b">${formatFileSize(file.size)}</b></p>
             <p style="margin:0 0 12px">ขนาดที่อนุญาต: <b style="color:#1e8449">ไม่เกิน 3 MB</b></p>
             <p style="margin:0;color:#555;font-size:14px">กรุณาลดขนาดไฟล์แล้วเลือกใหม่อีกครั้ง</p>`,
      confirmButtonText: "เลือกไฟล์ใหม่",
    });
    return false;
  }
  return true;
}

function FormProfileNewBee() {
  const {
    setValue,
    register,
    control,
    handleSubmit,
    clearErrors,
    formState: { errors },
    watch,
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      citizent: localStorage.getItem("citizent"),
      pname: "",
      name: "",
      lname: "",
      name_eng: "",
      lname_eng: "",
      gender: "",
      bdate: "",
      ddate: "",
      mdate: "",
      ydate: "",
      telephone: "",
      line_id: "",
      email: "",
      facebookid: "",
      nation_study: localStorage.getItem("nation_name"),
      believe_study: "",
      religion_study: "",
      weight_study: "",
      height_study: "",
      waistline_study: "",
      talent_study: "",
      number_study: "",
      moo_study: "",
      soi_study: "",
      street_study: "",
      provincy_study: "",
      district_study: "",
      subdistrict_study: "",
      zipcode_study: "",
      provincework: "",
      districtwork: "",
      schoolnamework: "",
      province: "",
      province2: "",
      district: "",
      district2: "",
      schoolname: "",
      schoolname2: "",
      level: localStorage.getItem("level"),
      plan: localStorage.getItem("plan"),
      vga: localStorage.getItem("vga"),
      level2: localStorage.getItem("level2"),
      plan2: localStorage.getItem("plan2"),
      vga2: localStorage.getItem("vga2"),
      level3: localStorage.getItem("level3"),
      plan3: localStorage.getItem("plan3"),
      vga3: localStorage.getItem("vga3"),
      filelevel: null,
      fileNotTH: "",
      filelevel2: "",
      fileData_1: null,
      fileData_3: null,
      filelevel_name: "",
      fileNotTH_name: "",
      fileData_1_name: "",
      fileData_3_name: "",
      scholarship: "",
      faculty: localStorage.getItem("faculty"),
      faculty2: localStorage.getItem("faculty2"),
      faculty3: localStorage.getItem("faculty3"),
      majorid: localStorage.getItem("majorid"),
      majorid2: localStorage.getItem("majorid2"),
      majorid3: localStorage.getItem("majorid3"),
      robId: localStorage.getItem("robId"),
      typestd: localStorage.getItem("typestd"),
      typestd2: localStorage.getItem("typestd2"),
      nation: localStorage.getItem("nation"),
      typestd3: localStorage.getItem("typestd3"),
      typestudent: localStorage.getItem("typestudent"),
      news1: false,
      news2: false,
      news3: false,
      news4: false,
      news5: false,
      news6: false,
      news7: false,
      news8: false,
      news9: false,
      news10: false,
      news11: false,
      type_pre: "",
      citizent_pre: "",
      name_pre: "",
      lname_pre: "",
      number_pre: "",
      moo_pre: "",
      soi_pre: "",
      street_pre: "",
      provincy_pre: "",
      district_pre: "",
      subdistrict_pre: "",
      zipcode_pre: "",
      mobile_pre: "",
      email_pre: "",
      checkconfirm: false,
      firstgen: "",
      test: false,
      DataProvince: [],
      DataLevel: [],
      DataLevel2: [],
      DataPlan1: [],
      DataPlan2: [],
      DataPrefix: [],
      DataDistrictStudy: [],
      DataDistrictWork: [],
      DataSubDistrictStudy: [],
      DataDistrictSchool: [],
      DataDistrictSchool2: [],
      DataSchool: [],
      DataSchool2: [],
      DataSchoolWork: [],
      DataDistrictPre: [],
      DataSubDistrictPre: [],
    },
  });
  const [DataYear, setDataYear] = useState([]);
  const [isShowForm2, setisShowForm2] = useState(false);
  const [isShowForm1, setisShowForm1] = useState(false);
  const [DataRegist, setDataRegist] = useState([]);
  const FetchYear = () => {
    var newyear = new Date().getFullYear();
    var startyear = newyear - 16;
    var stopyear = newyear - 130;
    var o = 0;
    var y = [];
    while (startyear > stopyear) {
      y[o] = startyear;
      o++;
      startyear--;
    }
    const ssss = y.map((d) => ({
      value: d.toString(),
      label: (d + 543).toString(),
    }));
    setDataYear(ssss);
  };
  const FetchPrefix = async () => {
    try {
      const fetch = await axios.get(admission + "/dashboard/prefix");
      const data = fetch.data;
      if (data.length !== 0) {
        const selection = data.map((i) => ({
          value: i.PREFIX_NAME_ID,
          label: i.FULLNAME,
        }));
        setValue("DataPrefix", selection);
      } else {
        setValue("DataPrefix", []);
      }
    } catch (error) { }
  };

  const FetchLevel = async () => {
    try {
      const fetch = await axios.get(mua + "/admission/level");
      const data = fetch.data;

      if (data.length !== 0) {
        const selection = data.map((i) => ({
          value: i.LEVEL_EDU_ID.toString(),
          label: i.LEVEL_EDU_NAME.toString(),
        }));
        setValue("DataLevel", selection);
      } else {
        setValue("DataLevel", []);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const FetchLevel2 = async () => {
    try {
      const fetch = await axios.get(mua + "/admission/level");
      const data = fetch.data;

      if (data.length !== 0) {
        const selection = data.map((i) => ({
          value: i.LEVEL_EDU_ID.toString(),
          label: i.LEVEL_EDU_NAME.toString(),
        }));
        setValue("DataLevel2", selection);
      } else {
        setValue("DataLevel2", []);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const FetchProvince = async () => {
    try {
      const fetch = await axios.get(mua + "/admissionnew2022/showprivenceschool");
      const data = fetch.data;

      if (data.length !== 0) {
        const selection = data.map((i) => ({
          value: i.PROVINCE_ID,
          label: i.PROVINCE_NAME_TH,
        }));

        setValue("DataProvince", selection);
      } else {
        setValue("DataProvince", []);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const FetchPlan1 = async () => {
    try {
      const fetch = await axios.post(mua + "/admission/plan", {
        level: localStorage.getItem("level"),
      });
      const data = fetch.data;
      if (data.length !== 0) {
        const selection = data.map((i) => ({
          value: i.value,
          label: i.label,
        }));

        setValue("DataPlan1", selection);
      } else {
        setValue("DataPlan1", []);
      }
      //   console.log(data);
    } catch (error) {
      console.log(error);
    }
  };
  const FetchPlan2 = async () => {
    try {
      const fetch = await axios.post(mua + "/admission/plan", {
        level: localStorage.getItem("level2"),
      });
      const data = fetch.data;
      if (data.length !== 0) {
        const selection = data.map((i) => ({
          value: i.value,
          label: i.label,
        }));

        setValue("DataPlan2", selection);
      } else {
        setValue("DataPlan2", []);
      }
      //   console.log(data);
    } catch (error) {
      console.log(error);
    }
  };
  const FetchSchool = async (value) => {
    try {
      const fetch = await axios.get(mua + "/admissionnew2022/showlistchool/" + value);
      const data = fetch.data;
      console.log(data);
      if (data.length !== 0) {
        const selection = data.map((i) => ({
          value: i.id_school,
          label: i.name_school,
        }));
        console.log(selection);
        return selection;
      } else {
        return [];
      }
    } catch (error) { }
  };

  const FetchProfile = async () => {
    try {
      setLoading(true);
      const fetch = await axios.post(admission + "/student/dataprofile", {
        citizen: watch("citizent"),
      });
      const data = fetch.data;

      if (data.length !== 0) {
        console.log(data);
        const profile = data[0];
        // setValue("pname", profile.PREFIX_LOGIN !== null ? profile.PREFIX_LOGIN : "");
        // setValue("name", profile.FRISTNAME_LOGIN !== null ? profile.FRISTNAME_LOGIN : "");
        // setValue("lname", profile.LASTNAME_LOGIN !== null ? profile.LASTNAME_LOGIN : "");
        // setValue("name_eng", profile.FRISTNAMEENG_LOGIN !== null ? profile.FRISTNAMEENG_LOGIN : "");
        // setValue("lname_eng", profile.LASTNAMEENG_LOGIN !== null ? profile.LASTNAMEENG_LOGIN : "");
        setValue("telephone", profile.TELMOBILE_LOGIN !== null ? profile.TELMOBILE_LOGIN : "");
        if (profile.BDATE_LOGIN !== null) {
          const bdate = profile.BDATE_LOGIN;
          const arraydate = bdate.split("-");
          setValue("ydate", arraydate[0]);
          setValue("mdate", arraydate[1]);
          setValue("ddate", arraydate[2]);
        }

        setValue(
          "email",
          profile.EMAIL_LOGIN !== null && profile.EMAIL_LOGIN !== " " ? profile.EMAIL_LOGIN : ""
        );
        setValue("facebookid", profile.FACEBOOK_LOGIN !== null ? profile.FACEBOOK_LOGIN : "");
        setValue("line_id", profile.LINE_LOGIN !== null ? profile.LINE_LOGIN : "");
        setValue("mobile_pre", profile.MOBILE_PRE !== null ? profile.MOBILE_PRE : "");
        setValue("believe_study", profile.RACE_LOGIN !== null ? profile.RACE_LOGIN : "");
        setValue("religion_study", profile.RELIGION_LOGIN !== null ? profile.RELIGION_LOGIN : "");
        setValue("number_study", profile.NUMBER_STUDY !== null ? profile.NUMBER_STUDY : "");
        setValue("moo_study", profile.MOO_STUDY !== null ? profile.MOO_STUDY : "");
        setValue("soi_study", profile.SOI_STUDY !== null ? profile.SOI_STUDY : "");
        setValue("street_study", profile.STREET_STUDY !== null ? profile.STREET_STUDY : "");
        setValue("provincy_study", profile.PROVINCY_STUDY !== null ? profile.PROVINCY_STUDY : "");
        setValue("weight_study", profile.WEIGHT_STUDY !== null ? profile.WEIGHT_STUDY : "");
        setValue("height_study", profile.HEIGHT_STUDY !== null ? profile.HEIGHT_STUDY : "");
        setValue(
          "waistline_study",
          profile.WAISTLINE_STUDY !== null ? profile.WAISTLINE_STUDY : ""
        );
        setValue("talent_study", profile.TALENT_LOGIN !== null ? profile.TALENT_LOGIN : "");
        if (profile.PROVINCY_STUDY !== "" && profile.PROVINCY_STUDY !== null) {
          const select = await FetchDistrict(profile.PROVINCY_STUDY);
          const select2 = await FetchSubDistrict(profile.DISTRICT_STUDY);
          setValue("district_study", profile.DISTRICT_STUDY);
          setValue("DataDistrictStudy", select);
          setValue("subdistrict_study", profile.SUBDISTRICT_STUDY);
          setValue("DataSubDistrictStudy", select2);
          setValue(
            "zipcode_study",
            select2?.find((option) => option.value === profile.SUBDISTRICT_STUDY).zipcode.toString()
          );
        }
        ThaiD();
        setLoading(false);
      } else {
        setLoading(false);
      }
      setLoading(false);
    } catch (error) { }
  };
  const ThaiD = async () => {
    try {
      const fetch = await axios.post(mua + "/admissionnew2022/ProfileThaID", {
        citizen: localStorage.getItem("citizent"),
      });
      const response = await fetch.data;
      if (response.length !== 0) {
        const profile = response[0];
        console.log();
        watch("DataPrefix") &&
          setValue(
            "pname",
            profile.PNAME !== null
              ? watch("DataPrefix").filter((val) => val.label === profile.PNAME)[0].value
              : ""
          );
        setValue("name", profile.NAME !== null ? profile.NAME : "");
        setValue("lname", profile.LNAME !== null ? profile.LNAME : "");
        setValue("name_eng", profile.NAME_EN !== null ? profile.NAME_EN : "");
        setValue("lname_eng", profile.LNAME_EN !== null ? profile.LNAME_EN : "");
        // setValue("telephone", profile.TELMOBILE_LOGIN !== null ? profile.TELMOBILE_LOGIN : "");
        if (profile.BIRTHDATE !== null) {
          const bdate = profile.BIRTHDATE;
          const arraydate = bdate.split("-");
          setValue("ydate", arraydate[0]);
          setValue("mdate", arraydate[1]);
          setValue("ddate", arraydate[2]);
        }

        setValue("number_study", profile.NUMBER_HOME !== null ? profile.NUMBER_HOME : "");
        setValue("moo_study", profile.MOO_HOME !== null ? profile.MOO_HOME : "");
        setValue("soi_study", profile.SOI_HOME !== null ? profile.SOI_HOME : "");
        setValue("street_study", profile.STREET_HOME !== null ? profile.STREET_HOME : "");
        setValue("provincy_study", profile.PROVINCY_HOME !== null ? profile.PROVINCY_HOME : "");
        if (profile.PROVINCY_HOME !== "" && profile.PROVINCY_HOME !== null) {
          const select = await FetchDistrict(profile.PROVINCY_HOME);
          const select2 = await FetchSubDistrict(profile.DRICTRICT_HOME);
          setValue("district_study", profile.DRICTRICT_HOME);
          setValue("DataDistrictStudy", select);
          setValue("subdistrict_study", profile.SUBDRICTRICT_HOME);
          setValue("DataSubDistrictStudy", select2);
          setValue(
            "zipcode_study",
            select2?.find((option) => option.value === profile.SUBDRICTRICT_HOME).zipcode.toString()
          );
        }
      }
      console.log(response);

      //  setValue("religion_study", profile.RELIGION_LOGIN !== null ? profile.RELIGION_LOGIN : "");
    } catch (error) {
      console.log(error);
    }
  };

  const [Laoading, setLoading] = useState(false);
  useEffect(() => {
    ThaiD();
    FetchYear();
    FetchLevel();
    FetchPlan1();
    FetchLevel2();
    FetchPlan2();
    FetchPrefix();
    FetchProvince();
    FetchProfile();
    if (watch("typestudent") === "5") {
      setValue("faculty", "2");
      setValue("majorid", "9901");
      setValue("typestd", "6");
    }
  }, []);
  const FetchDistrict = async (value) => {
    try {
      const fetch = await axios.post(mua + "/admission/district_register", {
        provincy_study: value,
      });
      const data = fetch.data;
      if (data.length !== 0) {
        const selection = data.map((i) => ({
          value: i.DISTRICT_ID,
          label: i.DISTRICT_NAME_TH,
        }));

        return selection;
      } else {
        return [];
      }
    } catch (error) { }
  };
  const FetchSubDistrict = async (value) => {
    try {
      const fetch = await axios.post(mua + "/admission/subdistrict_register", {
        district_study: value,
      });
      const data = fetch.data;
      if (data.length !== 0) {
        const selection = data.map((i) => ({
          value: i.SUB_DISTRICT_ID,
          label: i.SUB_DISTRICT_NAME_TH,
          zipcode: i.ZIPCODE,
        }));

        return selection;
      } else {
        return [];
      }
    } catch (error) { }
  };
  const [LoadRegister, setLoadRegister] = useState(false);
  const [pickerKey, setPickerKey] = useState({
    filelevel: 0,
    fileData_1: 0,
    fileData_3: 0,
  });

  const applyPdfField = (fieldName, files, docLabel) => {
    // Evergreen FilePicker ส่ง FileList หรือ File[]
    const file =
      files && files.length
        ? files[0]
        : files && files.target && files.target.files
          ? files.target.files[0]
          : null;
    if (!file) {
      setValue(fieldName, null, { shouldValidate: true });
      return;
    }
    if (!alertIfInvalidPdf(file, docLabel)) {
      setValue(fieldName, null, { shouldValidate: true });
      // รีเซ็ตช่อง Select file ให้ว่างหลังปฏิเสธไฟล์ใหญ่
      setPickerKey((k) => ({ ...k, [fieldName]: (k[fieldName] || 0) + 1 }));
      return;
    }
    setValue(fieldName, file, { shouldValidate: true });
  };

  const onSubmit = (data) => {
    const oversized = [
      { file: data.filelevel, label: "สำเนาใบรายงานผลการเรียน" },
      { file: data.fileData_3, label: "สำเนาบัตรประชาชน / เอกสารยืนยันตัวตน" },
      { file: data.fileData_1, label: "หนังสืออนุญาตประกอบวิชาชีพทางการศึกษา" },
    ].filter((x) => x.file && x.file.size > MAX_PDF_BYTES);

    if (oversized.length) {
      const rows = oversized
        .map(
          (x) =>
            `<li><b>${x.label}</b>: ${x.file.name} (${formatFileSize(x.file.size)})</li>`
        )
        .join("");
      Swal.fire({
        icon: "warning",
        title: "มีไฟล์ขนาดใหญ่เกินไป",
        html: `<p style="margin:0 0 8px;text-align:left">แต่ละไฟล์ต้องไม่เกิน <b>${formatFileSize(MAX_PDF_BYTES)}</b></p>
               <ul style="text-align:left;margin:0;padding-left:20px">${rows}</ul>
               <p style="margin:12px 0 0;text-align:left;color:#555">กรุณาลดขนาดแล้วอัปโหลดใหม่ก่อนส่งใบสมัคร</p>`,
        confirmButtonText: "ตกลง",
      });
      return;
    }

    setLoadRegister(true);
    const formdata = new FormData();
    if (data.filelevel) formdata.append("filelevel", data.filelevel);
    if (data.fileData_3) formdata.append("fileData_3", data.fileData_3);
    if (data.fileData_1) formdata.append("fileData_1", data.fileData_1);
    // อย่า JSON.stringify ไฟล์ — ส่งแยกใน FormData แล้ว (กัน payload พอง / 413)
    const {
      filelevel,
      fileData_1,
      fileData_3,
      filelevel2,
      ...payloadFields
    } = data;
    formdata.append("data", JSON.stringify(payloadFields));

    const headers = {
      Authorization: `Basic ${localStorage.getItem("token") || ""}`,
    };

    axios
      .post(mua + "/admissionnew2022/registers", formdata, { headers })
      .then((res) => {
        setisShowForm2(false);
        // รองรับทั้งสตริง "success" เดิม และ JSON ใหม่:
        // { status:200, status_name:"OK", data:{ success:"1", message:"success", ... } }
        const raw = res?.data;
        const payload =
          raw && typeof raw === "object" && raw.data != null ? raw.data : raw;

        const ok =
          raw === "success" ||
          payload === "success" ||
          payload?.success === "1" ||
          payload?.success === 1 ||
          payload?.message === "success" ||
          (typeof raw === "string" &&
            /\bsuccess\b/i.test(
              raw.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim()
            ));

        if (ok) {
          Swal.fire({
            icon: "success",
            title: "ส่งใบสมัครสำเร็จ",
            text: "กรุณารอสักครู่",
            timer: 900,
            timerProgressBar: true,
            showConfirmButton: false,
          }).then(() => {
            window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Dataregister`;
          });
          return;
        }

        const errText =
          (typeof payload === "object" &&
            (payload?.message || payload?.error || payload?.status_name)) ||
          (typeof raw === "object" &&
            (raw?.message || raw?.status_name || raw?.error)) ||
          (typeof raw === "string"
            ? raw.replace(/<[^>]+>/g, " ").trim()
            : "") ||
          "กรุณาติดต่อ 055-706547 / 088-273-0029";

        Swal.fire({
          icon: "error",
          title: "ส่งใบสมัครไม่สำเร็จ",
          text: String(errText).slice(0, 300),
        });
      })
      .catch((err) => {
        setisShowForm2(false);
        const status = err?.response?.status;
        const isNetworkCors =
          !err?.response &&
          /network error|cors|failed to fetch/i.test(String(err?.message || ""));
        let msg =
          err?.response?.data && typeof err.response.data === "string"
            ? err.response.data.replace(/<[^>]+>/g, " ").trim().slice(0, 300)
            : err?.message || "เชื่อมต่อเซิร์ฟเวอร์ไม่ได้";
        if (status === 413 || isNetworkCors) {
          msg =
            "ไฟล์แนบใหญ่เกินไป (หรือรวมกันเกินลิมิตเซิร์ฟเวอร์) กรุณาใช้ PDF ไม่เกิน 3 MB ต่อไฟล์ แล้วลองใหม่";
        }
        Swal.fire({
          icon: "error",
          title: "ส่งใบสมัครไม่สำเร็จ",
          text: msg,
        });
      })
      .finally(() => {
        setLoadRegister(false);
      });
  };
  useEffect(() => {
    const sizeRule = (label) => (v) => {
      if (!v) return `กรุณาอัปโหลด${label}`;
      if (!isPdfFile(v)) return "กรุณาเลือกไฟล์ PDF เท่านั้น";
      if (v.size > MAX_PDF_BYTES) {
        return `ไฟล์ใหญ่เกินไป (${formatFileSize(v.size)}) — ต้องไม่เกิน ${formatFileSize(MAX_PDF_BYTES)}`;
      }
      return true;
    };
    register("filelevel", { validate: sizeRule("สำเนาใบรายงานผลการเรียน") });
    register("fileData_3", {
      validate: sizeRule("สำเนาบัตรประชาชน / เอกสารยืนยันตัวตน"),
    });
  }, [register]);

  const CheckingForm = (data) => {
    setDataRegist(data);
    setisShowForm1(true);
  };
  const onInvalid = (formErrors) => {
    const items = listFieldErrors(formErrors);
    requestAnimationFrame(() => {
      const el = document.querySelector(
        ".form-profile .text-danger, .form-profile [aria-invalid='true']"
      );
      el?.scrollIntoView({ behavior: "smooth", block: "center" });
    });
    const html =
      items.length > 0
        ? `<p style="margin:0 0 8px;text-align:left">ยังไม่ได้กรอกหรือยังไม่ถูกต้อง:</p><ol style="text-align:left;margin:0;padding-left:20px">${items
            .map((i) => `<li><b>${i.label}</b> — ${i.message}</li>`)
            .join("")}</ol>`
        : "กรุณาตรวจช่องสีแดง";
    Swal.fire({
      icon: "warning",
      title: "ยังมีช่องที่ต้องแก้",
      html,
    });
  };
  const errorList = listFieldErrors(errors);

  return (
    <Pane className="container-sm mt-3 form-profile-page" padding={10} elevation={0}>
      {/* <Overlay isShown={Laoading}> */}

      {Laoading && (
        <Pane display="flex" justifyContent="center" alignItems="center">
          <Spinner />
        </Pane>
      )}
      {/* </Overlay> */}

      {!Laoading && (
        <>
          <Pane className="form-profile__hero">
            <h4>
              {localStorage.getItem("typestudent") === "1"
                ? "สมัครเรียนปริญญาตรีภาคปกติ (จันทร์-ศุกร์) มหาวิทยาลัยราชภัฏกำแพงเพชร"
                : localStorage.getItem("typestudent") === "2"
                  ? "สมัครเรียนปริญญาตรีภาคกศ.บป. (เสาร์-อาทิตย์) มหาวิทยาลัยราชภัฏกำแพงเพชร"
                  : localStorage.getItem("typestudent") === "4"
                    ? "สมัครเรียนปริญญาโท มหาวิทยาลัยราชภัฏกำแพงเพชร"
                    : localStorage.getItem("typestudent") === "7"
                      ? "สมัครเรียนปริญญาเอก มหาวิทยาลัยราชภัฏกำแพงเพชร"
                      : localStorage.getItem("typestudent") === "5"
                        ? " สมัครเรียนประกาศนียบัตรบัณฑิต สาขาวิชาชีพครู มหาวิทยาลัยราชภัฏกำแพงเพชร"
                        : "กรอกข้อมูลผู้สมัคร"}
            </h4>
            <p>กรอกข้อมูลให้ครบช่องที่มีเครื่องหมาย * และใช้ภาษาตามที่ระบุในแต่ละช่อง</p>
          </Pane>
          <Pane padding={10}>
            {/* <img src={thaid1} style={{ maxWidth: 120, cursor: "pointer" }} /> */}
            <form
              className="text-center text-white"
              action={arit + "/ap/ThaID/login.php"}
              method="post"
            >
              <div className="font-smaller mt-1 ml--1 mb-1 mr--1 text-center">หรือ</div>
              <input
                type="hidden"
                name="url"
                value={mua + "/thaid/callback"}
              />
              <input type="hidden" name="statusThaID" value="1" />
              <button id="btnLoginThaID" className="btn" name="button" value="thaid">
                <center>
                  <img
                    src={arit + "/ap/ThaID/images/thaID.png"}
                    class="rounded mr-1"
                    width="45"
                  />
                </center>
                <div className="d-flex flex-column">
                  <Text marginTop={10}>ใช้ข้อมูลพื้นฐานจาก ThaID</Text>
                  <Text color="red" fontSize={12}>
                    *หากไม่ใช้ สามารถกรอกข้อมูลได้ด้วยตนเอง
                  </Text>
                </div>
              </button>
            </form>
          </Pane>
          <form onSubmit={handleSubmit(CheckingForm, onInvalid)} className="pt-3 form-profile">
            {errorList.length > 0 && (
              <div className="form-profile__errors" role="alert">
                <strong>ยังมี {errorList.length} ช่องที่ต้องแก้</strong>
                <ol>
                  {errorList.map((item) => (
                    <li key={item.key}>
                      {item.label} — {item.message}
                    </li>
                  ))}
                </ol>
              </div>
            )}
            <div className="form-profile__legend">
              <span>
                <span className="req">*</span> ช่องบังคับต้องกรอก
              </span>
              <span className="lang-tag th">ชื่อ-นามสกุลไทย = ภาษาไทยเท่านั้น</span>
              <span className="lang-tag en">ชื่อ-นามสกุลอังกฤษ = A-Z เท่านั้น ห้ามไทย</span>
              <span className="lang-tag mail">อีเมล = รูปแบบ name@domain.com ห้ามไทย</span>
            </div>
            <Pane
              paddingTop={10}
              paddingX={0}
              margin={0}
              className="d-flex flex-md-row flex-column flex-wrap"
            >
              <div className="form-profile__section-title col-12">
                <span className="form-profile__step">1</span>
                ข้อมูลพื้นฐานผู้สมัคร
              </div>
              <Pane className="col-md-12">
                <TextInputField
                  readOnly
                  fontFamily=""
                  inputHeight={38}
                  paddingTop={6}
                  marginBottom={0}
                  disabled
                  label={
                    <span>
                      เลขบัตรประชาชน <span className="req">*</span>
                    </span>
                  }
                  {...register("citizent")}
                />
                {errors.citizent && (
                  <small className="text-danger">{errors.citizent.message}</small>
                )}
              </Pane>
              <Pane className="col-md-3">
                <label
                  htmlFor="pname"
                  style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                >
                  คำนำหน้า <span className="req">*</span>
                </label>
                {watch("DataPrefix").length > 0 && (
                  <Select
                    options={watch("DataPrefix")}
                    {...register("pname", {
                      required: "เลือกคำนำหน้าชื่อ",
                    })}
                    placeholder="เลือก"
                    defaultValue={watch("DataPrefix")?.find(
                      (option) => option.value === watch("pname")
                    )}
                    isSearchable
                    onChange={(e) => {
                      clearErrors("pname");
                      setValue("pname", e.value);
                    }}
                  />
                )}

                {errors.pname !== undefined && (
                  <small className="text-danger">{errors.pname.message}</small>
                )}
              </Pane>
              <Pane className={`col-md-5 ${errors.name ? "is-invalid" : ""}`}>
                <TextInputField
                  fontFamily=""
                  inputHeight={38}
                  paddingTop={6}
                  marginBottom={0}
                  isInvalid={!!errors.name}
                  label={
                    <span>
                      ชื่อภาษาไทย <span className="req">*</span>
                      <span className="lang-tag th">ภาษาไทยเท่านั้น</span>
                    </span>
                  }
                  placeholder="เช่น สมชาย"
                  {...register("name", rulesThaiName("ชื่อภาษาไทย"))}
                />
                {errors.name && <small className="text-danger">{errors.name.message}</small>}
              </Pane>
              <Pane className={`col-md-4 ${errors.lname ? "is-invalid" : ""}`}>
                <TextInputField
                  fontFamily=""
                  inputHeight={38}
                  paddingTop={6}
                  marginBottom={0}
                  isInvalid={!!errors.lname}
                  label={
                    <span>
                      นามสกุลภาษาไทย <span className="req">*</span>
                      <span className="lang-tag th">ภาษาไทยเท่านั้น</span>
                    </span>
                  }
                  placeholder="เช่น ใจดี"
                  {...register("lname", rulesThaiName("นามสกุลภาษาไทย"))}
                />
                {errors.lname && <small className="text-danger">{errors.lname.message}</small>}
              </Pane>
              <Pane className={`col-md-4 ${errors.name_eng ? "is-invalid" : ""}`}>
                <TextInputField
                  fontFamily=""
                  inputHeight={38}
                  paddingTop={6}
                  marginBottom={0}
                  isInvalid={!!errors.name_eng}
                  label={
                    <span>
                      ชื่อภาษาอังกฤษ <span className="req">*</span>
                      <span className="lang-tag en">English only</span>
                    </span>
                  }
                  placeholder="เช่น Somchai"
                  {...register("name_eng", rulesEnglishName("ชื่อภาษาอังกฤษ"))}
                />
                {errors.name_eng && (
                  <small className="text-danger">{errors.name_eng.message}</small>
                )}
              </Pane>
              <Pane className={`col-md-4 ${errors.lname_eng ? "is-invalid" : ""}`}>
                <TextInputField
                  fontFamily=""
                  inputHeight={38}
                  paddingTop={6}
                  marginBottom={0}
                  isInvalid={!!errors.lname_eng}
                  label={
                    <span>
                      นามสกุลภาษาอังกฤษ <span className="req">*</span>
                      <span className="lang-tag en">English only</span>
                    </span>
                  }
                  placeholder="เช่น Jaidee"
                  {...register("lname_eng", rulesEnglishName("นามสกุลภาษาอังกฤษ"))}
                />
                {errors.lname_eng && (
                  <small className="text-danger">{errors.lname_eng.message}</small>
                )}
              </Pane>
              <Pane className={`col-md-6 ${errors.telephone ? "is-invalid" : ""}`}>
                <TextInputField
                  fontFamily=""
                  inputHeight={38}
                  paddingTop={6}
                  marginBottom={0}
                  isInvalid={!!errors.telephone}
                  label={
                    <span>
                      เบอร์โทรศัพท์มือถือ <span className="req">*</span>
                    </span>
                  }
                  placeholder="เช่น 0812345678"
                  maxLength={10}
                  {...register("telephone", rulesPhone)}
                />
                {errors.telephone && (
                  <small className="text-danger">{errors.telephone.message}</small>
                )}
              </Pane>
              <Pane className={`col-md-6 ${errors.mobile_pre ? "is-invalid" : ""}`}>
                <TextInputField
                  fontFamily=""
                  inputHeight={38}
                  paddingTop={6}
                  marginBottom={0}
                  isInvalid={!!errors.mobile_pre}
                  label={
                    <span>
                      เบอร์โทรศัพท์มือถือผู้ปกครอง <span className="req">*</span>
                    </span>
                  }
                  placeholder="เช่น 0812345678"
                  maxLength={10}
                  {...register("mobile_pre", rulesPhone)}
                />
                {errors.mobile_pre && (
                  <small className="text-danger">{errors.mobile_pre.message}</small>
                )}
              </Pane>
              <Pane className="col-12 d-flex flex-md-row flex-column flex-wrap mt-2 p-0">
                <Pane className="col-md-4 ">
                  <label
                    htmlFor="ddate"
                    style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                  >
                    วันเกิด <span className="req">*</span>
                  </label>
                  {day.length !== 0 && (
                    <Select
                      {...register("ddate", {
                        required: "กรุณาเลือกวันเกิด",
                      })}
                      placeholder="เลือกวันเกิด"
                      options={day}
                      defaultValue={day?.find((option) => option.value === watch("ddate"))}
                      isSearchable
                      onChange={(e) => {
                        clearErrors("ddate");
                        setValue("ddate", e.value);
                      }}
                    />
                  )}

                  {errors.ddate && <small className="text-danger">{errors.ddate.message}</small>}
                </Pane>
                <Pane className="col-md-4 ">
                  <label
                    htmlFor="mdate"
                    style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                  >
                    เดือนเกิด <span className="req">*</span>
                  </label>
                  {Array.isArray(month) && (
                    <Select
                      {...register("mdate", {
                        required: "เลือกเลือกเดือนเกิด",
                      })}
                      placeholder="เลือกเดือนเกิด"
                      options={month}
                      defaultValue={month?.find((option) => option.value === watch("mdate"))}
                      isSearchable
                      onChange={(e) => {
                        clearErrors("mdate");
                        setValue("mdate", e.value);
                      }}
                    />
                  )}

                  {errors.mdate && <small className="text-danger">{errors.mdate.message}</small>}
                </Pane>
                <Pane className="col-md-4 ">
                  <label
                    htmlFor="ydate"
                    style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                  >
                    ปีเกิด <span className="req">*</span>
                  </label>
                  {DataYear.length !== 0 && (
                    <Select
                      {...register("ydate", {
                        required: "กรุณาเลือกปีเกิด",
                      })}
                      placeholder="กรุณาเลือกปีเกิด"
                      options={DataYear}
                      defaultValue={DataYear?.find((option) => option.value === watch("ydate"))}
                      isSearchable
                      onChange={(e) => {
                        clearErrors("ydate");
                        setValue("ydate", e.value);
                      }}
                    />
                  )}

                  {errors.ydate && <small className="text-danger">{errors.ydate.message}</small>}
                </Pane>
              </Pane>
              <Pane className={`col-md-4 ${errors.email ? "is-invalid" : ""}`}>
                <TextInputField
                  fontFamily=""
                  inputHeight={38}
                  paddingTop={6}
                  marginBottom={0}
                  isInvalid={!!errors.email}
                  label={
                    <span>
                      อีเมล <span className="req">*</span>
                      <span className="lang-tag mail">name@example.com</span>
                    </span>
                  }
                  placeholder="name@example.com"
                  type="email"
                  {...register("email", rulesEmail)}
                />
                <span className="field-hint">ใช้ตัวอักษรอังกฤษเท่านั้น ห้ามมีภาษาไทยหรือเว้นวรรค</span>
                {errors.email && <small className="text-danger">{errors.email.message}</small>}
              </Pane>
              <Pane className="col-md-4">
                <TextInputField
                  fontFamily=""
                  inputHeight={38}
                  paddingTop={6}
                  marginBottom={0}
                  label={
                    <span>
                      ชื่อ Facebook <span className="req">*</span>
                    </span>
                  }
                  {...register("facebookid", {
                    required: "กรุณากรอกชื่อ Facebook",
                  })}
                />
                {errors.facebookid && (
                  <small className="text-danger">{errors.facebookid.message}</small>
                )}
              </Pane>
              <Pane className="col-md-4">
                <TextInputField
                  fontFamily=""
                  inputHeight={38}
                  paddingTop={6}
                  marginBottom={0}
                  label={
                    <span>
                      Line ID <span className="req">*</span>
                    </span>
                  }
                  {...register("line_id", {
                    required: "กรุณากรอกข้อมูล Line ID",
                  })}
                />
                {errors.line_id && <small className="text-danger">{errors.line_id.message}</small>}
              </Pane>
              <div className="col-12"></div>
              <Pane className="col-md-4">
                <TextInputField
                  fontFamily=""
                  inputHeight={38}
                  paddingTop={6}
                  marginBottom={0}
                  readOnly
                  disabled
                  label={
                    <span>
                      สัญชาติ <span className="req">*</span>
                    </span>
                  }
                  {...register("nation_study")}
                />
                {errors.nation_study && (
                  <small className="text-danger">{errors.nation_study.message}</small>
                )}
              </Pane>
              <Pane className="col-md-4">
                <label
                  htmlFor="believe_study"
                  style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                >
                  เชื้อชาติ <span className="req">*</span>
                </label>
                {selectorigin.length !== 0 && (
                  <Select
                    {...register("believe_study", {
                      required: "กรุณาเลือกเชื้อชาติ",
                    })}
                    placeholder="กรุณาเลือกเชื้อชาติ"
                    options={selectorigin}
                    isSearchable
                    defaultValue={selectorigin?.find(
                      (option) => option.value === watch("believe_study")
                    )}
                    onChange={(e) => {
                      clearErrors("believe_study");
                      setValue("believe_study", e.value);
                    }}
                  />
                )}

                {errors.believe_study && (
                  <small className="text-danger">{errors.believe_study.message}</small>
                )}
              </Pane>
              <Pane className="col-md-4">
                <label
                  htmlFor="religion_study"
                  style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                >
                  ศาสนา <span className="req">*</span>
                </label>
                {selectreligion.length !== 0 && (
                  <Select
                    {...register("religion_study", {
                      required: "กรุณาเลือกศาสนา",
                    })}
                    placeholder="กรุณาเลือกศาสนา"
                    options={selectreligion}
                    defaultValue={selectreligion?.find(
                      (option) => option.value === watch("religion_study")
                    )}
                    isSearchable
                    onChange={(e) => {
                      clearErrors("religion_study");
                      setValue("religion_study", e.value);
                    }}
                  />
                )}

                {errors.religion_study && (
                  <small className="text-danger">{errors.religion_study.message}</small>
                )}
              </Pane>
              {(localStorage.getItem("majorid") === "9902" ||
                localStorage.getItem("majorid") === "9903") && (
                  <>
                    {/* <hr width="100%" /> */}
                    <Pane className="col-md-4">
                      <TextInputField
                        fontFamily=""
                        inputHeight={38}
                        paddingTop={6}
                        marginBottom={0}
                        label="น้ำหนัก"
                        {...register("weight_study", {
                          required: "กรุณากรอกข้อมูล",
                        })}
                      />
                      {errors.weight_study && (
                        <small className="text-danger">{errors.weight_study.message}</small>
                      )}
                    </Pane>
                    <Pane className="col-md-4">
                      <TextInputField
                        fontFamily=""
                        inputHeight={38}
                        paddingTop={6}
                        marginBottom={0}
                        label="ส่วนสูง"
                        {...register("height_study", {
                          required: "กรุณากรอกข้อมูล",
                        })}
                      />
                      {errors.height_study && (
                        <small className="text-danger">{errors.height_study.message}</small>
                      )}
                    </Pane>
                    <Pane className="col-md-4">
                      <TextInputField
                        fontFamily=""
                        inputHeight={38}
                        paddingTop={6}
                        marginBottom={0}
                        label="รอบเอว"
                        {...register("waistline_study", {
                          required: "กรุณากรอกข้อมูล",
                        })}
                      />
                      {errors.waistline_study && (
                        <small className="text-danger">{errors.waistline_study.message}</small>
                      )}
                    </Pane>
                    <Pane className="col-md-4">
                      <TextInputField
                        fontFamily=""
                        inputHeight={38}
                        paddingTop={6}
                        marginBottom={0}
                        label="ความสามารถพิเศษ *ไม่มีให้ใส่ -"
                        {...register("talent_study", {
                          required: "กรุณากรอกข้อมูล",
                        })}
                      />
                      {errors.talent_study && (
                        <small className="text-danger">{errors.talent_study.message}</small>
                      )}
                    </Pane>
                  </>
                )}
              <hr width="100%" />
              <div className="form-profile__section-title col-12">
                <span className="form-profile__step">2</span>
                ข้อมูลที่อยู่ตามทะเบียนบ้าน
              </div>
              <Pane className="col-md-3">
                <TextInputField
                  fontFamily=""
                  inputHeight={38}
                  paddingTop={6}
                  marginBottom={0}
                  label={
                    <span>
                      บ้านเลขที่ <span className="req">*</span>
                    </span>
                  }
                  {...register("number_study", {
                    required: "กรุณากรอกบ้านเลขที่",
                  })}
                />
                {errors.number_study && (
                  <small className="text-danger">{errors.number_study.message}</small>
                )}
              </Pane>
              <Pane className="col-md-3">
                <TextInputField
                  fontFamily=""
                  inputHeight={38}
                  paddingTop={6}
                  marginBottom={0}
                  label="หมู่ที่"
                  {...register("moo_study")}
                />
                {errors.moo_study && (
                  <small className="text-danger">{errors.moo_study.message}</small>
                )}
              </Pane>
              <Pane className="col-md-3">
                <TextInputField
                  fontFamily=""
                  inputHeight={38}
                  paddingTop={6}
                  marginBottom={0}
                  label="ซอย (ไม่มีให้ใส่ -)"
                  {...register("soi_study")}
                />
                {errors.soi_study && (
                  <small className="text-danger">{errors.soi_study.message}</small>
                )}
              </Pane>
              <Pane className="col-md-3">
                <TextInputField
                  fontFamily=""
                  inputHeight={38}
                  paddingTop={6}
                  marginBottom={0}
                  label="ถนน (ไม่มีให้ใส่ -)"
                  {...register("street_study")}
                />
                {errors.street_study && (
                  <small className="text-danger">{errors.street_study.message}</small>
                )}
              </Pane>
              <Pane className="col-md-4">
                <label
                  htmlFor="religion_study"
                  style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                >
                  จังหวัด
                </label>
                {watch("DataProvince").length !== 0 && (
                  <Select
                    {...register("provincy_study", {
                      required: "กรุณาเลือกจังหวัด",
                    })}
                    defaultValue={watch("DataProvince")?.find(
                      (option) => option.value === watch("provincy_study")
                    )}
                    placeholder="กรุณาเลือกจังหวัด"
                    options={watch("DataProvince")}
                    isSearchable
                    onChange={async (e) => {
                      clearErrors("provincy_study");
                      const select = await FetchDistrict(e.value);
                      setValue("DataDistrictStudy", select);
                      setValue("district_study", "");
                      setValue("subdistrict_study", "");
                      setValue("zipcode_study", "");
                      setValue("provincy_study", e.value);
                    }}
                  />
                )}

                {errors.provincy_study && (
                  <small className="text-danger">{errors.provincy_study.message}</small>
                )}
              </Pane>
              <Pane className="col-md-4">
                <label
                  htmlFor="district_study"
                  style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                >
                  อำเภอ/เขต
                </label>
                {Array.isArray(watch("DataDistrictStudy")) && (
                  <Select
                    {...register("district_study", {
                      required: "กรุณาเลือกอำเภอ",
                    })}
                    placeholder="กรุณาเลือกอำเภอ"
                    options={watch("DataDistrictStudy")}
                    isSearchable
                    defaultValue={watch("DataDistrictStudy")?.find(
                      (option) => option.value === watch("district_study")
                    )}
                    onChange={async (e) => {
                      clearErrors("district_study");
                      const select = await FetchSubDistrict(e.value);
                      setValue("DataSubDistrictStudy", select);
                      setValue("subdistrict_study", "");
                      setValue("zipcode_study", "");
                      setValue("district_study", e.value);
                    }}
                  />
                )}

                {errors.district_study && (
                  <small className="text-danger">{errors.district_study.message}</small>
                )}
              </Pane>
              <Pane className="col-md-4">
                <label
                  htmlFor="subdistrict_study"
                  style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                >
                  ตำบล/แขวง
                </label>
                {Array.isArray(watch("DataSubDistrictStudy")) && (
                  <Select
                    {...register("subdistrict_study", {
                      required: "กรุณาเลือกตำบล",
                    })}
                    placeholder="กรุณาเลือกตำบล"
                    options={watch("DataSubDistrictStudy")}
                    defaultValue={watch("DataSubDistrictStudy")?.find(
                      (option) => option.value === watch("subdistrict_study")
                    )}
                    isSearchable
                    onChange={(e) => {
                      clearErrors("subdistrict_study");
                      setValue(
                        "zipcode_study",
                        watch("DataSubDistrictStudy")
                          ?.find((option) => option.value === e.value)
                          .zipcode.toString()
                      );
                      setValue("subdistrict_study", e.value);
                    }}
                  />
                )}

                {errors.subdistrict_study && (
                  <small className="text-danger">{errors.subdistrict_study.message}</small>
                )}
              </Pane>
              <Pane className="col-md-4">
                <TextInputField
                  fontFamily=""
                  inputHeight={38}
                  paddingTop={6}
                  marginBottom={0}
                  label={
                    <span>
                      รหัสไปรษณีย์ <span className="req">*</span>
                    </span>
                  }
                  {...register("zipcode_study", rulesZipcode)}
                />
                {errors.zipcode_study && (
                  <small className="text-danger">{errors.zipcode_study.message}</small>
                )}
              </Pane>
              {(localStorage.getItem("majorid") === "9902" ||
                localStorage.getItem("majorid") === "9903") && (
                  <>
                    <hr width="100%" />
                    <div className="form-profile__section-title col-12">
                      <span className="form-profile__step">2b</span>
                      ข้อมูลผู้ปกครอง
                    </div>
                    <Pane className="col-md-4">
                      <label
                        htmlFor="type_pre"
                        style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                      >
                        ประเภทผู้ปกครอง
                      </label>
                      <Select
                        {...register("type_pre", {
                          required: "กรุณาเลือก",
                        })}
                        placeholder="กรุณาเลือก"
                        options={objTypePre_Bak}
                        isSearchable
                        onChange={async (e) => {
                          clearErrors("type_pre");
                          setValue("type_pre", e.value);
                        }}
                      />
                      {errors.type_pre && (
                        <small className="text-danger">{errors.type_pre.message}</small>
                      )}
                    </Pane>
                    <Pane className="col-md-4">
                      <TextInputField
                        fontFamily=""
                        inputHeight={38}
                        paddingTop={6}
                        marginBottom={0}
                        label={
                          <span>
                            เลขบัตรประชาชนผู้ปกครอง <span className="req">*</span>
                          </span>
                        }
                        maxLength={13}
                        {...register("citizent_pre", rulesCitizenId)}
                      />
                      {errors.citizent_pre && (
                        <small className="text-danger">{errors.citizent_pre.message}</small>
                      )}
                    </Pane>
                    <Pane className="col-md-4">
                      <TextInputField
                        fontFamily=""
                        inputHeight={38}
                        paddingTop={6}
                        marginBottom={0}
                        label={
                          <span>
                            ชื่อภาษาไทย <span className="req">*</span>
                            <span className="lang-tag th">ภาษาไทยเท่านั้น</span>
                          </span>
                        }
                        {...register("name_pre", rulesThaiName("ชื่อผู้ปกครอง"))}
                      />
                      {errors.name_pre && (
                        <small className="text-danger">{errors.name_pre.message}</small>
                      )}
                    </Pane>
                    <Pane className="col-md-4">
                      <TextInputField
                        fontFamily=""
                        inputHeight={38}
                        paddingTop={6}
                        marginBottom={0}
                        label={
                          <span>
                            นามสกุลภาษาไทย <span className="req">*</span>
                            <span className="lang-tag th">ภาษาไทยเท่านั้น</span>
                          </span>
                        }
                        {...register("lname_pre", rulesThaiName("นามสกุลผู้ปกครอง"))}
                      />
                      {errors.lname_pre && (
                        <small className="text-danger">{errors.lname_pre.message}</small>
                      )}
                    </Pane>
                    <Pane className="col-md-4">
                      <TextInputField
                        fontFamily=""
                        inputHeight={38}
                        paddingTop={6}
                        marginBottom={0}
                        label={
                          <span>
                            เบอร์โทรศัพท์ <span className="req">*</span>
                          </span>
                        }
                        {...register("mobile_pre", rulesPhone)}
                      />
                      {errors.mobile_pre && (
                        <small className="text-danger">{errors.mobile_pre.message}</small>
                      )}
                    </Pane>
                    <Pane className="col-md-4">
                      <TextInputField
                        fontFamily=""
                        inputHeight={38}
                        paddingTop={6}
                        marginBottom={0}
                        label={
                          <span>
                            อีเมลผู้ปกครอง <span className="req">*</span>
                            <span className="lang-tag mail">หรือใส่ -</span>
                          </span>
                        }
                        placeholder="name@example.com หรือ -"
                        {...register("email_pre", rulesEmailOrDash)}
                      />
                      {errors.email_pre && (
                        <small className="text-danger">{errors.email_pre.message}</small>
                      )}
                    </Pane>

                    <Pane className="col-md-3">
                      <TextInputField
                        fontFamily=""
                        inputHeight={38}
                        paddingTop={6}
                        marginBottom={0}
                        label="บ้านเลขที่"
                        {...register("number_pre", {
                          required: "กรุณากรอกข้อมูล",
                        })}
                      />
                      {errors.number_pre && (
                        <small className="text-danger">{errors.number_pre.message}</small>
                      )}
                    </Pane>
                    <Pane className="col-md-3">
                      <TextInputField
                        fontFamily=""
                        inputHeight={38}
                        paddingTop={6}
                        marginBottom={0}
                        label="หมู่ที่"
                        {...register("moo_pre", {
                          required: "กรุณากรอกข้อมูล",
                        })}
                      />
                      {errors.moo_pre && (
                        <small className="text-danger">{errors.moo_pre.message}</small>
                      )}
                    </Pane>
                    <Pane className="col-md-3">
                      <TextInputField
                        fontFamily=""
                        inputHeight={38}
                        paddingTop={6}
                        marginBottom={0}
                        label="ซอย *หากไม่มี ใส่ -"
                        {...register("soi_pre")}
                      />
                      {errors.soi_pre && (
                        <small className="text-danger">{errors.soi_pre.message}</small>
                      )}
                    </Pane>
                    <Pane className="col-md-3">
                      <TextInputField
                        fontFamily=""
                        inputHeight={38}
                        paddingTop={6}
                        marginBottom={0}
                        label="ถนน *หากไม่มี ใส่ -"
                        {...register("street_pre")}
                      />
                      {errors.street_pre && (
                        <small className="text-danger">{errors.street_pre.message}</small>
                      )}
                    </Pane>
                    <Pane className="col-md-4">
                      <label
                        htmlFor="religion_study"
                        style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                      >
                        จังหวัด
                      </label>
                      {watch("DataProvince").length !== 0 && (
                        <Select
                          {...register("provincy_pre", {
                            required: "กรุณาเลือกจังหวัด",
                          })}
                          defaultValue={watch("DataProvince")?.find(
                            (option) => option.value === watch("provincy_pre")
                          )}
                          placeholder="กรุณาเลือกจังหวัด"
                          options={watch("DataProvince")}
                          isSearchable
                          onChange={async (e) => {
                            clearErrors("provincy_pre");
                            const select = await FetchDistrict(e.value);
                            setValue("DataDistrictPre", select);
                            setValue("district_pre", "");
                            setValue("subdistrict_pre", "");
                            setValue("zipcode_pre", "");
                            setValue("provincy_pre", e.value);
                          }}
                        />
                      )}

                      {errors.provincy_pre && (
                        <small className="text-danger">{errors.provincy_pre.message}</small>
                      )}
                    </Pane>
                    <Pane className="col-md-4">
                      <label
                        htmlFor="district_pre"
                        style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                      >
                        อำเภอ/เขต
                      </label>
                      {Array.isArray(watch("DataDistrictStudy")) && (
                        <Select
                          {...register("district_pre", {
                            required: "กรุณาเลือกอำเภอ",
                          })}
                          placeholder="กรุณาเลือกอำเภอ"
                          options={watch("DataDistrictPre")}
                          isSearchable
                          defaultValue={watch("DataDistrictPre")?.find(
                            (option) => option.value === watch("district_pre")
                          )}
                          onChange={async (e) => {
                            clearErrors("district_pre");
                            const select = await FetchSubDistrict(e.value);
                            setValue("DataSubDistrictPre", select);
                            setValue("subdistrict_pre", "");
                            setValue("zipcode_pre", "");
                            setValue("district_pre", e.value);
                          }}
                        />
                      )}

                      {errors.district_pre && (
                        <small className="text-danger">{errors.district_pre.message}</small>
                      )}
                    </Pane>
                    <Pane className="col-md-4">
                      <label
                        htmlFor="subdistrict_pre"
                        style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                      >
                        ตำบล/แขวง
                      </label>
                      {Array.isArray(watch("DataSubDistrictPre")) && (
                        <Select
                          {...register("subdistrict_pre", {
                            required: "กรุณาเลือกตำบล",
                          })}
                          placeholder="กรุณาเลือกตำบล"
                          options={watch("DataSubDistrictPre")}
                          defaultValue={watch("DataSubDistrictPre")?.find(
                            (option) => option.value === watch("subdistrict_pre")
                          )}
                          isSearchable
                          onChange={(e) => {
                            clearErrors("subdistrict_pre");
                            setValue(
                              "zipcode_pre",
                              watch("DataSubDistrictPre")
                                ?.find((option) => option.value === e.value)
                                .zipcode.toString()
                            );
                            setValue("subdistrict_pre", e.value);
                          }}
                        />
                      )}

                      {errors.subdistrict_pre && (
                        <small className="text-danger">{errors.subdistrict_pre.message}</small>
                      )}
                    </Pane>
                    <Pane className="col-md-4">
                      <TextInputField
                        fontFamily=""
                        inputHeight={38}
                        paddingTop={6}
                        marginBottom={0}
                        label={
                          <span>
                            รหัสไปรษณีย์ <span className="req">*</span>
                          </span>
                        }
                        {...register("zipcode_pre", rulesZipcode)}
                      />
                      {errors.zipcode_pre && (
                        <small className="text-danger">{errors.zipcode_pre.message}</small>
                      )}
                    </Pane>
                  </>
                )}
              <hr width="100%" />
              <div className="form-profile__section-title col-12">
                <span className="form-profile__step">3</span>
                ข้อมูลทางการศึกษา
              </div>
              <Pane
                border="default"
                borderRadius={8}
                minHeight={50}
                borderColor={"#edc531"}
                marginTop={10}
                className="col-12"
                backgroundColor={"#fdf8e1"}
                padding={15}
              >
                <Text color={"red"} fontWeight="700" fontSize="18" fontFamily="">
                  *หากไม่พบข้อมูล โทร. 055-706547 / 088-273-0029 หรือ
                </Text>
                <br />
                <Text color={"red"} fontWeight="700" fontSize={18} fontFamily="">
                  *ติดต่อที่ เพจ Facebook ={">"} :
                  <a href="https://www.facebook.com/AdmissionKPRU" target="_blank" rel="noreferrer">
                    &nbsp; &nbsp;&nbsp; <FaFacebook /> รับสมัครนักศึกษามหาวิทยาลัยราชภัฏกำแพงเพชร
                  </a>
                </Text>
              </Pane>
              {/* ///ป ครู */}
              {localStorage.getItem("typestudent") === "5" && (
                <>
                  <Pane className="col-12 d-flex flex-md-row flex-column flex-wrap mt-2 p-0">
                    {" "}
                    <Text fontSize={20} fontWeight={600} fontFamily="" className="col-12">
                      ข้อมูลสถานศึกษาที่ปฏิบัติหน้าที่/ปฏิบัติการสอน
                    </Text>
                    <Pane className="col-md-4">
                      <label
                        htmlFor="provincework"
                        style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                      >
                        จังหวัดที่ปฏิบัติหน้าที่/ปฏิบัติการสอน
                      </label>
                      <Select
                        {...register("provincework", {
                          required: "กรุณาเลือกจังหวัด",
                        })}
                        placeholder="กรุณาเลือกจังหวัด"
                        options={watch("DataProvince")}
                        isSearchable
                        onChange={async (e) => {
                          clearErrors("provincework");
                          const select = await FetchDistrict(e.value);
                          setValue("DataDistrictWork", select);
                          setValue("districtwork", "");
                          setValue("schoolnamework", "");
                          setValue("provincework", e.value);
                        }}
                      />
                      {errors.provincework && (
                        <small className="text-danger">{errors.provincework.message}</small>
                      )}
                    </Pane>
                    <Pane className="col-md-4">
                      <label
                        htmlFor="district"
                        style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                      >
                        อำเภอ/เขตที่ตั้งสถานศึกษาที่ปฏิบัติการสอน
                      </label>
                      {/* {Array.isArray("DataDistrictSchool") && ( */}
                      <Select
                        {...register("districtwork", {
                          required: "กรุณาเลือกอำเภอ/เขต",
                        })}
                        placeholder="กรุณาเลือกอำเภอ/เขต"
                        options={watch("DataDistrictWork")}
                        isSearchable
                        onChange={async (e) => {
                          clearErrors("districtwork");
                          const select = await FetchSchool(e.value);
                          setValue("DataSchoolWork", select);
                          setValue("districtwork", e.value);
                        }}
                      />
                      {/* )} */}

                      {errors.districtwork && (
                        <small className="text-danger">{errors.districtwork.message}</small>
                      )}
                    </Pane>
                    <Pane className="col-md-4">
                      <label
                        htmlFor="schoolnamework"
                        style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                      >
                        สถานศึกษาที่ที่ปฏิบัติการสอน
                      </label>
                      <Select
                        {...register("schoolnamework", {
                          required: "กรุณาเลือกสถานศึกษาที่ที่ปฏิบัติการสอน",
                        })}
                        placeholder="กรุณาเลือกสถานศึกษา"
                        options={watch("DataSchoolWork")}
                        isSearchable
                        onChange={(e) => {
                          clearErrors("schoolnamework");
                          setValue("schoolnamework", e.value);
                        }}
                      />
                      {errors.schoolnamework && (
                        <small className="text-danger">{errors.schoolnamework.message}</small>
                      )}
                    </Pane>{" "}
                  </Pane>
                  <Text fontSize={20} fontWeight={600} fontFamily="" className="col-12 mt-2 mb-2">
                    ข้อมูลสถานศึกษาที่สำเร็จการศึกษา
                  </Text>
                </>
              )}
              {localStorage.getItem("typestd") === "4" ||
                (localStorage.getItem("typestd") === "7" && (
                  <Pane className="col-12 mt-2">
                    <Text fontWeight={500} fontSize={16}>
                      ระดับปริญญาตรี
                    </Text>
                  </Pane>
                ))}
              <Pane className="col-md-4">
                <label
                  htmlFor="province"
                  style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                >
                  จังหวัดที่ตั้งสถานศึกษาที่สำเร็จการศึกษา
                </label>
                <Select
                  {...register("province", {
                    required: "กรุณาเลือกจังหวัด",
                  })}
                  placeholder="กรุณาเลือกจังหวัด"
                  options={watch("DataProvince")}
                  isSearchable
                  onChange={async (e) => {
                    clearErrors("province");
                    const select = await FetchDistrict(e.value);
                    setValue("DataDistrictSchool", select);
                    setValue("district", "");
                    setValue("schoolname", "");
                    setValue("province", e.value);
                  }}
                />
                {errors.province && (
                  <small className="text-danger">{errors.province.message}</small>
                )}
              </Pane>
              <Pane className="col-md-4">
                <label
                  htmlFor="district"
                  style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                >
                  อำเภอ/เขตที่ตั้งสถานศึกษาที่สำเร็จการศึกษา
                </label>
                {/* {Array.isArray("DataDistrictSchool") && ( */}
                <Select
                  {...register("district", {
                    required: "กรุณาเลือกอำเภอ/เขต",
                  })}
                  placeholder="กรุณาเลือกอำเภอ/เขต"
                  options={watch("DataDistrictSchool")}
                  isSearchable
                  onChange={async (e) => {
                    clearErrors("district");
                    const select = await FetchSchool(e.value);
                    setValue("DataSchool", select);
                    setValue("district", e.value);
                  }}
                />
                {/* )} */}

                {errors.district && (
                  <small className="text-danger">{errors.district.message}</small>
                )}
              </Pane>
              <Pane className="col-md-4">
                <label
                  htmlFor="schoolname"
                  style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                >
                  สถานศึกษาที่สำเร็จการศึกษา
                </label>
                <Select
                  {...register("schoolname", {
                    required: "กรุณาเลือกสถานศึกษาที่สำเร็จการศึกษา",
                  })}
                  placeholder="กรุณาเลือกสถานศึกษา"
                  options={watch("DataSchool")}
                  isSearchable
                  onChange={(e) => {
                    clearErrors("schoolname");
                    setValue("schoolname", e.value);
                  }}
                />
                {errors.schoolname && (
                  <small className="text-danger">{errors.schoolname.message}</small>
                )}
              </Pane>
              <Pane className="col-md-4">
                <label
                  htmlFor="level"
                  style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                >
                  วุฒิการศึกษาที่สำเร็จการศึกษา
                </label>
                {watch("DataLevel").length !== 0 && (
                  <Select
                    {...register("level", {})}
                    isDisabled
                    placeholder="กรุณาเลือกตำบล"
                    options={watch("DataLevel")}
                    defaultValue={watch("DataLevel")?.find(
                      (option) => option.value === watch("level")
                    )}
                    isSearchable
                  />
                )}
              </Pane>
              <Pane className="col-md-4">
                <label
                  htmlFor="plan"
                  style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                >
                  แผนการเรียนที่สำเร็จการศึกษา
                </label>
                {watch("DataPlan1").length !== 0 && (
                  <Select
                    {...register("plan")}
                    isDisabled
                    options={watch("DataPlan1")}
                    defaultValue={watch("DataPlan1")?.find(
                      (option) => option.value === watch("plan")
                    )}
                    isSearchable
                  />
                )}
              </Pane>
              <Pane className="col-md-4">
                <TextInputField
                  fontFamily=""
                  readOnly
                  inputHeight={38}
                  paddingTop={6}
                  disabled
                  marginBottom={0}
                  label="ผลการเรียนเฉลี่ย"
                  {...register("vga")}
                />
                {errors.vga && <small className="text-danger">{errors.vga.message}</small>}
              </Pane>
              {localStorage.getItem("typestd") === "7" && (
                <Pane className="col-12 mt-2">
                  <Text fontWeight={500} fontSize={16}>
                    ระดับปริญญาโท
                  </Text>
                </Pane>
              )}
              {localStorage.getItem("typestd") === "7" && (
                <>
                  <Pane className="col-md-4">
                    <label
                      htmlFor="province2"
                      style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                    >
                      จังหวัดที่ตั้งสถานศึกษาที่สำเร็จการศึกษา
                    </label>
                    <Select
                      {...register("province2", {
                        required: "กรุณาเลือกจังหวัด",
                      })}
                      placeholder="กรุณาเลือกจังหวัด"
                      options={watch("DataProvince")}
                      isSearchable
                      onChange={async (e) => {
                        clearErrors("province2");
                        const select = await FetchDistrict(e.value);
                        setValue("DataDistrictSchool2", select);
                        setValue("district2", "");
                        setValue("schoolname2", "");
                        setValue("province2", e.value);
                      }}
                    />
                    {errors.province2 && (
                      <small className="text-danger">{errors.province2.message}</small>
                    )}
                  </Pane>
                  <Pane className="col-md-4">
                    <label
                      htmlFor="district2"
                      style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                    >
                      อำเภอ/เขตที่ตั้งสถานศึกษาที่สำเร็จการศึกษา
                    </label>
                    {/* {Array.isArray("DataDistrictSchool") && ( */}
                    <Select
                      {...register("district2", {
                        required: "กรุณาเลือกอำเภอ/เขต",
                      })}
                      placeholder="กรุณาเลือกอำเภอ/เขต"
                      options={watch("DataDistrictSchool2")}
                      isSearchable
                      onChange={async (e) => {
                        clearErrors("district2");
                        const select = await FetchSchool(e.value);
                        setValue("DataSchool2", select);
                        setValue("district2", e.value);
                      }}
                    />
                    {/* )} */}

                    {errors.district2 && (
                      <small className="text-danger">{errors.district2.message}</small>
                    )}
                  </Pane>
                  <Pane className="col-md-4">
                    <label
                      htmlFor="schoolname2"
                      style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                    >
                      สถานศึกษาที่สำเร็จการศึกษา
                    </label>
                    <Select
                      {...register("schoolname2", {
                        required: "กรุณาเลือกสถานศึกษาที่สำเร็จการศึกษา",
                      })}
                      placeholder="กรุณาเลือกสถานศึกษา"
                      options={watch("DataSchool2")}
                      isSearchable
                      onChange={(e) => {
                        clearErrors("schoolname2");
                        setValue("schoolname2", e.value);
                      }}
                    />
                    {errors.schoolname2 && (
                      <small className="text-danger">{errors.schoolname2.message}</small>
                    )}
                  </Pane>
                  <Pane className="col-md-4">
                    <label
                      htmlFor="level2"
                      style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                    >
                      วุฒิการศึกษาที่สำเร็จการศึกษา
                    </label>
                    {watch("DataLevel2").length !== 0 && (
                      <Select
                        {...register("level2", {})}
                        isDisabled
                        placeholder="วุฒิการศึกษาที่สำเร็จการศึกษา"
                        options={watch("DataLevel2")}
                        defaultValue={watch("DataLevel2")?.find(
                          (option) => option.value === watch("level2")
                        )}
                        isSearchable
                      />
                    )}
                  </Pane>
                  <Pane className="col-md-4">
                    <label
                      htmlFor="plan2"
                      style={{ fontSize: 14, marginBottom: 5, marginTop: 7, fontWeight: 400 }}
                    >
                      แผนการเรียนที่สำเร็จการศึกษา
                    </label>
                    {watch("DataPlan2").length !== 0 && (
                      <Select
                        {...register("plan2")}
                        isDisabled
                        options={watch("DataPlan2")}
                        defaultValue={watch("DataPlan2")?.find(
                          (option) => option.value === watch("plan2")
                        )}
                        isSearchable
                      />
                    )}
                  </Pane>
                  <Pane className="col-md-4">
                    <TextInputField
                      fontFamily=""
                      readOnly
                      inputHeight={38}
                      paddingTop={6}
                      disabled
                      marginBottom={0}
                      label="ผลการเรียนเฉลี่ย"
                      {...register("vga2")}
                    />
                    {errors.vga2 && <small className="text-danger">{errors.vga2.message}</small>}
                  </Pane>
                </>
              )}
              <div className="form-profile__section-title col-12">
                <span className="form-profile__step">4</span>
                ไฟล์เอกสารต่าง ๆ
              </div>
              <Pane
                border="default"
                borderRadius={8}
                minHeight={50}
                borderColor={"#abc4ff"}
                marginTop={10}
                className="col-12"
                backgroundColor={"#edf2fb"}
                padding={15}
                display={"flex"}
                gap={5}
                flexDirection={"column"}
              >
                <Text color="#274c77">
                  *หลักฐานที่อัพโหลดเข้าระบบต้องสำเนาถูกต้องและลงลายมือชื่อให้เรียบร้อย
                </Text>
                <Text color="#274c77">
                  *สำหรับผู้ที่ไม่มีสัญชาติไทยให้แนบสำเนาบัตรประจำตัวผู้ไม่มีสัญชาติไทยมากับสำเนาเอกสารใบรายงานผลการเรียนด้วย
                </Text>
                <IoMdHelpBuoy color="#ff6b35" />
                <Text color="#274c77">
                  *ลิงก์สำหรับรวมไฟล์ PDF ={">"}{" "}
                  <Button
                    type="button"
                    size="small"
                    appearance="primary"
                    intent="success"
                    onClick={() => {
                      window.open("https://www.ilovepdf.com/th/merge_pdf");
                    }}
                  >
                    คลิกที่นี่
                  </Button>
                </Text>
                <Text color="#274c77">
                  *ลิงก์สำหรับบีบอัดหรือแปลงไฟล์ ={">"}{" "}
                  <Button
                    type="button"
                    size="small"
                    appearance="primary"
                    intent="success"
                    onClick={() => {
                      window.open("https://www.ilovepdf.com/th/jpg_to_pdf");
                    }}
                  >
                    คลิกที่นี่
                  </Button>
                </Text>
              </Pane>
              {localStorage.getItem("typestudent") === "5" && (
                <Pane className="col-12 mt-2">
                  <Text
                    className="col-12 mt-1 text-danger"
                    fontSize={16}
                    fontWeight={500}
                    fontFamily=""
                  >
                    หนังสืออนุญาตให้ประกอบวิชาชีพทางการศึกษา
                  </Text>
                  <FilePicker
                    key={`fileData_1-${pickerKey.fileData_1}`}
                    accept={".pdf,application/pdf"}
                    multiple={false}
                    placeholder="ไฟล์ PDF ขนาดไม่เกิน 3 MB"
                    onChange={(files) =>
                      applyPdfField(
                        "fileData_1",
                        files,
                        "หนังสืออนุญาตให้ประกอบวิชาชีพทางการศึกษา"
                      )
                    }
                  />
                  <input
                    {...register("fileData_1", {
                      required: "กรุณาอัพโหลดเอกสาร",
                      validate: (v) => {
                        if (!v) return "กรุณาอัพโหลดเอกสาร";
                        if (!isPdfFile(v)) return "กรุณาเลือกไฟล์ PDF เท่านั้น";
                        if (v.size > MAX_PDF_BYTES) {
                          return `ไฟล์ใหญ่เกินไป (${formatFileSize(v.size)}) — ต้องไม่เกิน ${formatFileSize(MAX_PDF_BYTES)}`;
                        }
                        return true;
                      },
                    })}
                    className="d-none"
                  />
                  {watch("fileData_1")?.name && (
                    <small className="text-success d-block mt-1">
                      เลือกแล้ว: {watch("fileData_1").name} ({formatFileSize(watch("fileData_1").size)})
                    </small>
                  )}
                  {errors.fileData_1 && (
                    <small className="text-danger">{errors.fileData_1.message}</small>
                  )}
                  <br />
                  <Text
                    className="col-12 mt-1 text-success"
                    fontSize={12}
                    fontWeight={500}
                    fontFamily=""
                  >
                    ไฟล์ตัวอย่าง
                  </Text>
                  <Button
                    onClick={() => {
                      window.open(muaStatic + "/imagesbg/examplefilenothai.pdf");
                    }}
                    type="button"
                    size="small"
                    appearance="primary"
                  >
                    คลิกที่นี่
                  </Button>
                </Pane>
              )}
              <Pane className="col-12 mt-2">
                <Text
                  className="col-12 mt-1 text-danger"
                  fontSize={16}
                  fontWeight={500}
                  fontFamily=""
                >
                  สำเนาเอกสารใบรายงานผลการเรียนที่สำเร็จการศึกษา
                  {localStorage.getItem("typestd") === "7" && " ระดับปริญญาโท"}
                </Text>
                <FilePicker
                  key={`filelevel-${pickerKey.filelevel}`}
                  accept={".pdf,application/pdf"}
                  multiple={false}
                  placeholder="ไฟล์ PDF ขนาดไม่เกิน 3 MB"
                  onChange={(files) =>
                    applyPdfField(
                      "filelevel",
                      files,
                      "สำเนาเอกสารใบรายงานผลการเรียนที่สำเร็จการศึกษา"
                    )
                  }
                />
                {watch("filelevel")?.name && (
                  <small className="text-success d-block mt-1">
                    เลือกแล้ว: {watch("filelevel").name} ({formatFileSize(watch("filelevel").size)})
                  </small>
                )}
                {errors.filelevel && (
                  <small className="text-danger">{errors.filelevel.message}</small>
                )}
                <br />
                <Text
                  className="col-12 mt-1 text-success"
                  fontSize={12}
                  fontWeight={500}
                  fontFamily=""
                >
                  ไฟล์ตัวอย่าง
                </Text>
                <Button
                  onClick={() => {
                    window.open(muaStatic + "/imagesbg/examplefilenothai.pdf");
                  }}
                  type="button"
                  size="small"
                  appearance="primary"
                >
                  คลิกที่นี่
                </Button>
              </Pane>
              <Pane className="col-12 mt-3">
                <Text
                  className="col-12 mt-1 text-danger"
                  fontSize={14}
                  fontWeight={500}
                  fontFamily=""
                >
                  สำเนาบัตรประจำตัวประชาชน / สำเนาบัตรประจำตัวบุคคลที่ไม่มีสถานะทางทะเบียน/
                  สำเนาบัตรประจำตัวคนซึ่งไม่มีสัญชาติไทย/ สำเนาหนังสือเดินทาง /
                  สำเนาเอกสารใบทะเบียนนักเรียนรายบุคคล (นักเรียนติด G)
                </Text>
                <FilePicker
                  key={`fileData_3-${pickerKey.fileData_3}`}
                  accept={".pdf,application/pdf"}
                  multiple={false}
                  placeholder="ไฟล์ PDF ขนาดไม่เกิน 3 MB"
                  onChange={(files) =>
                    applyPdfField(
                      "fileData_3",
                      files,
                      "สำเนาบัตรประจำตัวประชาชน / เอกสารยืนยันตัวตน"
                    )
                  }
                />
                {watch("fileData_3")?.name && (
                  <small className="text-success d-block mt-1">
                    เลือกแล้ว: {watch("fileData_3").name} ({formatFileSize(watch("fileData_3").size)})
                  </small>
                )}
                {errors.fileData_3 && (
                  <small className="text-danger">{errors.fileData_3.message}</small>
                )}
                <br />
              </Pane>
              <hr width="100%" />
              <div className="form-profile__section-title col-12">
                <span className="form-profile__step">5</span>
                ข้อมูลทางการศึกษาบิดาหรือมารดา
              </div>
              <Text className="col-12 mt-1">
                บิดาหรือมารดาของท่านสำเร็จการศึกษาในระดับปริญญาตรีขึ้นไป หรือไม่ ?{" "}
                <span className="req">*</span>
              </Text>
              <Pane className="col-12">
                <Controller
                  name="firstgen"
                  control={control}
                  rules={{
                    validate: (v) =>
                      v === "0" ||
                      v === "1" ||
                      "กรุณาเลือกข้อมูลการศึกษาบิดาหรือมารดา",
                  }}
                  render={({ field }) => (
                    <Pane>
                      {firstgen.map((item) => (
                        <Radio
                          key={item.value}
                          size={16}
                          name={field.name}
                          label={item.label}
                          value={item.value}
                          checked={field.value === item.value}
                          onChange={() => {
                            field.onChange(item.value);
                            clearErrors("firstgen");
                          }}
                        />
                      ))}
                    </Pane>
                  )}
                />
                {errors.firstgen && (
                  <small className="text-danger">{errors.firstgen.message}</small>
                )}
              </Pane>
              <hr width="100%" />
              <div className="form-profile__section-title col-12">
                <span className="form-profile__step">6</span>
                ข้อมูลช่องทางรับข่าวสาร
              </div>
              <Text className="col-12 mt-1">
                นักศึกษาทราบช่องทางการสมัครเข้ามหาวิทยาลัยได้จากช่องทางใดบ้าง
              </Text>
              <Group flexDirection={"column"} paddingTop={10}>
                <Checkbox
                  marginBottom={5}
                  checked={watch("news1")}
                  onChange={(e) => setValue("news1", e.target.checked)}
                  label="เว็บไซต์มหาวิทยาลัยราชภัฏกำแพงเพชร"
                />
                <Checkbox
                  margin={5}
                  checked={watch("news2")}
                  onChange={(e) => setValue("news2", e.target.checked)}
                  label="โปสเตอร์/แผ่นประกาศ/แผ่นพับ/ใบปลิว"
                />
                <Checkbox
                  margin={5}
                  checked={watch("news3")}
                  onChange={(e) => setValue("news3", e.target.checked)}
                  label="YouTube / Tiktok"
                />
                <Checkbox
                  margin={5}
                  checked={watch("news4")}
                  onChange={(e) => setValue("news4", e.target.checked)}
                  label="สื่อวิทยุ"
                />
                <Checkbox
                  margin={5}
                  checked={watch("news5")}
                  onChange={(e) => setValue("news5", e.target.checked)}
                  label="ผู้ปกครอง"
                />
                <Checkbox
                  margin={5}
                  checked={watch("news6")}
                  onChange={(e) => setValue("news6", e.target.checked)}
                  label="Facebook"
                />
                <Checkbox
                  margin={5}
                  checked={watch("news7")}
                  onChange={(e) => setValue("news7", e.target.checked)}
                  label="ครูแนะแนว"
                />
                <Checkbox
                  margin={5}
                  checked={watch("news8")}
                  onChange={(e) => setValue("news8", e.target.checked)}
                  label="ป้ายประชาสัมพันธ์"
                />
                <Checkbox
                  margin={5}
                  checked={watch("news9")}
                  onChange={(e) => setValue("news9", e.target.checked)}
                  label="นิทรรศการวิชาการ"
                />
                <Checkbox
                  margin={5}
                  checked={watch("news11")}
                  onChange={(e) => setValue("news11", e.target.checked)}
                  label="แนะแนวการศึกษาของมหาวิทยาลัย"
                />
                <Checkbox
                  margin={5}
                  checked={watch("news10")}
                  onChange={(e) => setValue("news10", e.target.checked)}
                  label="อื่นๆ"
                />
              </Group>
              <Pane
                border="default"
                borderRadius={8}
                minHeight={50}
                borderColor={"#de6d17"}
                marginTop={10}
                className="col-12"
                backgroundColor={"#fde1cb"}
                padding={15}
                display={"flex"}
                gap={5}
                flexDirection={"row"}
              >
                <Text color="#de6d17" display="flex">
                  <Checkbox
                    width={10}
                    marginRight={20}
                    checked={watch("checkconfirm")}
                    onChange={(e) => {
                      setValue("checkconfirm", e.target.checked);
                    }}
                  />
                  ข้าพเจ้าขอรับรองว่าข้อมูลในใบสมัครฉบับนี้มีความครบถ้วน
                  ถูกต้องและตรงตามความเป็นจริงทุกประการ
                  และยินยอมให้มหาวิทยาลัยราชภัฏกำแพงเพชรจัดเก็บข้อมูล เผยแพร่
                  และส่งต่อเพื่อใช้งานภายในมหาวิทยาลัยราชภัฏกำแพงเพชร
                </Text>
              </Pane>
              <Pane className="col-12 mt-3 form-profile__submit">
                <Button
                  disabled={
                    !(
                      watch("news1") ||
                      watch("news2") ||
                      watch("news3") ||
                      watch("news4") ||
                      watch("news5") ||
                      watch("news6") ||
                      watch("news7") ||
                      watch("news8") ||
                      watch("news9") ||
                      watch("news11") ||
                      watch("news10")
                    ) || !watch("checkconfirm")
                  }
                  type="submit"
                  appearance="primary"
                  intent="success"
                >
                  ตรวจสอบและบันทึกการสมัครเรียน
                </Button>
              </Pane>
            </Pane>
          </form>
        </>
      )}
      <Dialog
        isShown={isShowForm1}
        hasFooter={false}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEscapePress={false}
        width={900}
        preventBodyScrolling={true}
        onCloseComplete={() => {
          setisShowForm1(false);
        }}
      >
        <Iframe
          // url="https://docs.google.com/forms/d/1IpJ5knXxI8Mm4WnkNbDfb8EhNgWvSdUdvGDFQrAftu4/viewform?edit_requested=true"
          url="https://docs.google.com/forms/d/e/1FAIpQLScHDhBU5lPsSOcXUrCNwLb6zqX_pP8YC9kwPWh_N9RYZCdxpg/viewform?edit_requested=true"
          width="100%"
          height="500px"
          id="myIds"
          className="myClassname"
          display="initial"
          position="relative"
        />
        <Pane>
          <Button
            onClick={() => {
              setisShowForm1(false);
              onSubmit(DataRegist);
              // setisShowForm2(true);
            }}
            appearance="primary"
            intent="success"
          >
            ตอบแบบสอบถามแล้ว
          </Button>
        </Pane>
      </Dialog>
      <Dialog
        isShown={isShowForm2}
        hasFooter={false}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEscapePress={false}
        width={900}
        preventBodyScrolling={true}
      >
        <Iframe
          url="https://docs.google.com/forms/d/e/1FAIpQLScHDhBU5lPsSOcXUrCNwLb6zqX_pP8YC9kwPWh_N9RYZCdxpg/viewform?edit_requested=true"
          width="100%"
          height="500px"
          id="myIds"
          className="myClassname"
          display="initial"
          position="relative"
        />
        <Pane>
          <Button
            isLoading={LoadRegister}
            onClick={() => {
              // onSubmit(DataRegist);
            }}
            appearance="primary"
            intent="success"
          >
            ตอบแบบสอบถามแล้ว
          </Button>
        </Pane>
      </Dialog>
    </Pane>
  );
}

export default FormProfileNewBee;


